import classNames from "classnames";
import { CSSProperties, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";

const AnimateBox = ({
  className,
  children,
  style = {},
  classNameIn,
  classNameOut,
}: {
  className?: string;
  children: any;
  style?: CSSProperties
    classNameIn?: string;
    classNameOut?: string;
}) => {
  const [isShow, setIsShow] = useState(true);
  const domRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    // 判断元素是否在视口内
    const isInViewport = (element: HTMLElement) => {
      const rect = element.getBoundingClientRect();
      const centerY = rect.top + rect.height / 2;
      return (
        centerY >= 0 &&
        centerY <= clientHeight
      );
    }
    const handleScroll = () => {
      if (domRef.current && isInViewport(domRef.current)) {
        setIsShow(true);
      } else {
        setIsShow(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // 初始化检查一次
    return () => {
      window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return (
    <div
      ref={domRef}
      className={classNames(
        "animate__animated",
        {
          [`animate__${classNameIn}`]: isShow,
          [`animate__${classNameOut}`]: !isShow,
        },
        className
      )}
      style={{
        animationDuration: "1s",
        ...style
      }}
    >
      {children}
    </div>
  );
};
export default AnimateBox;
